export namespace ScreeningStatusTypeConstants {
  export const NEW: string = 'new';
  export const PENDING: string = 'pending';
  export const CANCELLED: string = 'cancelled';
  export const ERROR: string = 'error';
  export const EXPIRED: string = 'expired';
  export const COMPLETE: string = 'complete';
  export const ENROLLED: string = 'enrolled';
}
